var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({
      height: '100%',
      'border-radius': '5px',
    }),attrs:{"id":_vm.mapId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }